module.exports = __webpack_public_path__ + "static/media/tagliatelle.a7d230dd.jpg";